var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tpl no-result-wrap"},[_c('div',{staticClass:"no-content"},[_c('img',{attrs:{"src":require("../../assets/img/default/bg_img_404@2x.png")}}),_vm._v(" "),_c('p',[_vm._v("页面去哪了？(⊙ˍ⊙)")]),_vm._v(" "),_c('router-link',{attrs:{"tag":"button","to":"/"}},[_vm._v("回到主页")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09ca9422","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/404.vue
// module id = null
// module chunks = 